import React from 'react'
import { GridLayout } from '@uswitch/ev-core/react'
import { getValue } from './utils'
import { ButtonLink } from '../../elements/button-link'
import { TruTick } from '@uswitch/spark-icons/tru'

const { Row, Column } = GridLayout

const EligibilityInformation = ({ content, data, headerImage, onClick }) => {
  const formatValue = value => {
    if (value === true || value === 'Yes' || value === 'yes' || value === 'true') {
      if (headerImage) {
        return (
          <React.Fragment>
            <div
              sx={{ variant: `elements.eligibility-criteria.variants.redesign.item.value.icon` }}
            >
              <TruTick color={'#6bab51'} size={18} />
            </div>
            <div
              sx={{ variant: `elements.eligibility-criteria.variants.redesign.item.value.text` }}
            >
              Yes
            </div>
          </React.Fragment>
        )
      }

      return 'Yes'
    }
    if (value === false) return 'No'
    return value
  }

  const renderList = section => (
    <Choose>
      <When condition={section.type === 'additional'}>
        <ul sx={{ variant: 'elements.eligibility-criteria.item.additional' }}>
          <For each='item' of={section.list} index='key'>
            <li key={key}>{getValue(item.value, data)}</li>
          </For>
        </ul>
      </When>
      <When condition={section.type === 'cta'}>
        <ButtonLink
          onClick={onClick}
          variant='primary'
          href={getValue(section.primary.href, data)}
          target='_blank'
          sx={{
            variant: `elements.eligibility-criteria.${headerImage && 'variants.redesign.'}item.cta`,
          }}
        >
          {getValue(section.primary.text, data)}
        </ButtonLink>
      </When>
      <Otherwise>
        <For each='item' of={section.list} index='key'>
          <Choose>
            <When condition={item.icon}>
              <div
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <TruTick color={'#6bab51'} size={18} sx={{ mt: '0', mr: 'md' }} />
                <span
                  sx={{
                    variant: `elements.eligibility-criteria.${
                      headerImage && 'variants.redesign.'
                    }item.title`,
                  }}
                >
                  {item.label}
                </span>
                <span
                  sx={{
                    variant: `elements.eligibility-criteria.${
                      headerImage && 'variants.redesign.'
                    }item.value`,
                  }}
                >
                  {`${getValue(item.value, data)}`}
                </span>
              </div>
            </When>
            <Otherwise>
              <div
                sx={{
                  variant: `elements.eligibility-criteria.${
                    headerImage && 'variants.redesign.'
                  }item.base`,
                }}
              >
                <span
                  sx={{
                    variant: `elements.eligibility-criteria.${
                      headerImage && 'variants.redesign.'
                    }item.title`,
                  }}
                >
                  {item.label}
                </span>
                <span
                  sx={{
                    variant: `elements.eligibility-criteria.${
                      headerImage && 'variants.redesign.'
                    }item.value`,
                  }}
                >
                  {formatValue(getValue(item.value, data))}
                </span>
              </div>
            </Otherwise>
          </Choose>
        </For>
      </Otherwise>
    </Choose>
  )

  return (
    <Row sx={{ margin: 0 }}>
      <For each='section' of={content}>
        <Column
          s={1 / 1}
          m={4 / 12}
          l={4 / 12}
          sx={{
            paddingBottom: headerImage ? [0, 'lg'] : 'lg',
            paddingX: ['sm', '12px'],
            paddingTop: [0, '1px'],
            '&:first-of-type': { paddingLeft: ['sm', 'lg'], paddingTop: '1px' },
            '&:last-child': { paddingRight: ['sm', 'lg'] },
          }}
        >
          <div
            sx={{
              variant: `elements.eligibility-criteria.${headerImage && 'variants.redesign.'}base`,
              display: section.type === 'cta' && ['block', 'none'],
            }}
          >
            <span
              sx={{
                variant: `elements.eligibility-criteria.${
                  headerImage && 'variants.redesign.'
                }title`,
              }}
            >
              {getValue(section.title)}
            </span>
            <If condition={section.subtitle}>
              <span sx={{ variant: 'elements.eligibility-criteria.subtitle' }}>
                {getValue(section.subtitle)}
              </span>
            </If>

            <If condition={section.label}>
              <span
                sx={{
                  mb: section.type === 'additional' ? 'sm' : 'md',
                  variant: `elements.eligibility-criteria.${
                    headerImage && 'variants.redesign.'
                  }label`,
                }}
              >
                {getValue(section.label)}
              </span>
            </If>
            {renderList(section)}
            <If condition={section.subscript}>
              <span sx={{ variant: 'elements.eligibility-criteria.subscript' }}>
                {getValue(section.subscript)}
              </span>
            </If>
          </div>
        </Column>
      </For>
    </Row>
  )
}

export default EligibilityInformation
